import {useState} from 'react'
import {useOutletContext} from 'react-router'
import {Button} from 'brand/Button'
import {justValues, dailyMakeup} from './answers'

const answers = justValues(dailyMakeup)

export const DailyMakeup = () => {
  const {submitAnswers} = useOutletContext()
  const [answer, setAnswer] = useState()

  const select = choice => {
    setAnswer(choice)
  }

  return (
    <>
      <div className="column">
        <section className="question">
          <div className="content size-xl">How much makeup do you like to wear?</div>
        </section>
        <section className="answers">
          <div className="content">
            {answers.map(it => (
              <Button size="large"
                action={() => select(it)}
                selected={it === answer}
                key={it}
              >
                {it}
              </Button>
            ))}
          </div>
        </section>
      </div>
      <section className="float-bottom">
        <div className="content">
          <Button
            size="large"
            tone={answer ? 'highlight' : 'lowlight'}
            action={() => submitAnswers([answer])}
          >
            Personalise a look for me
          </Button>
        </div>
      </section>
    </>
  )
}
